import http from '../utils/http';

export const getNotifications = (query) => http.get(`/messaging/notifications${query ? `?${query}` : ''}`);

export const sendNotification = (data) =>
  http.post('/messaging', {
    ...data,
  });

export const getCampaigns = (query) => http.get(`/messaging/campaigns${query ? `?${query}` : ''}`);

export const createCampaign = (data) => http.post('/messaging/campaigns', data);

export const cancelCampaign = (id) => http.post(`/messaging/campaigns/${id}/cancel`);

export const countCampaignAudience = (audience) => http.post('/messaging/campaigns/audience/count', { audience });
